import { Component } from '@verndale/core';

class Accordion extends Component {
  layout: string = 'block';

  constructor(el: HTMLElement, layout?: string) {
    super(el);
    if (layout) {
      this.layout = layout;
    }
  }

  setupDefaults() {
    this.dom = {
      triggers: this.el.querySelectorAll('.accordion__item-trigger'),
      panels: this.el.querySelectorAll('.accordion__item-panel')
    };

    this.initAccordion();
  }

  addListeners() {
    (this.dom.triggers as NodeList).forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );
  }

  initAccordion() {
    (this.dom.triggers as NodeListOf<HTMLButtonElement>).forEach(trigger => {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.openItem(trigger);
      }
    });
  }

  handleClick(e: Event) {
    const isCollapsable = this.el.dataset.isCollapsable === 'true';
    const trigger = e.currentTarget as HTMLButtonElement;
    if (isCollapsable) {
      (this.dom.triggers as NodeListOf<HTMLElement>).forEach(item => {
        if (item.getAttribute('aria-expanded') === 'true') {
          this.closeItem(item as HTMLButtonElement);
        } else if (item.getAttribute('aria-expanded') === 'false' && item === trigger) {
          this.openItem(item as HTMLButtonElement);
        }
      });
    } else {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        this.closeItem(trigger);
      } else {
        this.openItem(trigger);
      }
    }
  }

  openItem(trigger: HTMLButtonElement) {
    trigger.setAttribute('aria-expanded', 'true');

    const panel = document.getElementById(trigger.getAttribute('aria-controls') as string);

    if (panel) {
      panel.removeAttribute('style');
      panel.style.display = this.layout;
      const pannelContent = panel.querySelector<HTMLElement>('.accordion__item-content');

      panel.style.height = `${pannelContent?.offsetHeight}px`;

      setTimeout(() => {
        panel.style.height = 'auto';
        panel.style.display = this.layout;
      }, 250);
    }
  }

  closeItem(trigger: HTMLButtonElement) {
    trigger.setAttribute('aria-expanded', 'false');

    const panel = document.getElementById(trigger.getAttribute('aria-controls') as string);

    if (panel) {
      const pannelContent = panel.querySelector<HTMLElement>('.accordion__item-content');
      panel.style.height = `${pannelContent?.offsetHeight}px`;
      setTimeout(() => (panel.style.height = '0px'));
      setTimeout(() => (panel.style.display = 'none'), 500);
    }
  }
}

export default Accordion;
